import { sendWebsocketMessage, socketStore } from '../../../../../../App';

export function addWrappedTradePlan({ requestId, tradePlan, wrapSource }) {
  socketStore.wrapTradePlanStore.beginWrappedTradePlanSubmit({ requestId });

  sendWebsocketMessage({
    messageType: 'addWrappedTradePlan',
    requestId,
    addWrappedTradePlan: {
      tradePlan,
      wrapSource,
    },
  });
}
